const getDirectionDefaults = (direction) => {
  switch (direction) {
    case "vertical": {
      return { flexDirection: "column" };
    }
    case "horizontal":
    default: {
      return { flexDirection: "row", alignItems: "center", justifyContent: "flex-start" };
    }
  }
};
const getGap = (size) => {
  if (typeof size === "number") {
    return `${size}px`;
  }
  switch (size) {
    case "l":
      return "32px";
    case "m":
      return "16px";
    case "s":
    default:
      return "8px";
  }
};
export {
  getDirectionDefaults,
  getGap
};
//# sourceMappingURL=Spacer.helpers.js.map
